const localAddress = 'http://rbxext.test'
const address = {
    baseURL: process.env.NODE_ENV === 'production' ? '/api' : `${localAddress}/api`,
    baseURLMedia: process.env.NODE_ENV === 'production' ? '/' : localAddress
};

export default address
